import { Component, NgZone } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { APIServiceProvider } from '../../common/services/api.service';
import { HelperServiceProvider } from '../../common/services/helper.service';
import { ModalsBankReceiptPage } from '../../modals/modals-bank-receipt/modals-bank-receipt';
import { NotifyService } from '../../services/notify.service';

/**
 * Generated class for the BankReceiptHistoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-bank-receipt-history',
  templateUrl: 'bank-receipt-history.html',
})
export class BankReceiptHistoryPage {
  public ordersData: any = [];
  public ordersApiResponse: any;
  private apiUrl: any = "order/finance/finance-bank-receipts";
  public postParams: any = {
    limit: 10,
    associate_id: [localStorage.getItem("user-id")]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public apiService: APIServiceProvider,
    public zone: NgZone,
    public helperService: HelperServiceProvider,
    public modalController: ModalController,
    private notifyService: NotifyService
  ) {
    this.notifyService.orderCancelled.subscribe(() => {
      this.getOrders();
    });
  }

  ionViewDidLoad() {
    this.getOrders();
  }

  getOrders(refresh ? ) {
    this.apiService.post(this.apiUrl, this.postParams).subscribe(data => {
      this.ordersData = data["data"]["data"];
      this.ordersApiResponse = data["data"];
      if (refresh) {
        refresh.complete();
      }
    });
  }
  showOrderDetailsModalInfo(data, status, heading){
      let modalObject = this.modalController.create(ModalsBankReceiptPage, {
        param: data,
        status: status,
        heading: heading,
      });
  
      modalObject.present();
  
  }
  doInfiniteScroll(infiniteScroll) {
    if (!this.ordersApiResponse.next_page_url ||
      this.ordersApiResponse.next_page_url === "" ||
      this.ordersApiResponse.next_page_url === null ||
      this.ordersApiResponse.next_page_url === "null"
    ) {
      infiniteScroll.complete();
      return;
    }
    this.apiService
      .post(this.apiUrl, this.postParams, this.ordersApiResponse.next_page_url)
      .subscribe(data => {
        this.ordersApiResponse = data["data"];
        this.ordersData = this.ordersData.concat(data["data"]["data"]);
        infiniteScroll.complete();
      });
  }




  getOrderDetails(order_id) {
    return new Promise((resolve, reject) => {
      const params = {
        order_id
      };
      this.apiService
        .post("orders/get-order-details", params)
        .subscribe(result => {
          resolve(result);
        });
    });
  }

  doRefresh(refresher) {
    this.getOrders(refresher);
  }

}



// WEBPACK FOOTER //
// ./src/pages/bank-receipt-history/bank-receipt-history.ts